
import React from "react";

const ContactHero = () => {
  return (
    <section className="pt-20 pb-8 bg-gradient-to-b from-transparent via-white/10 to-white/20">
      <div className="container px-4">
        <div className="max-w-2xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-4">
            Contact
            <span className="block text-primary">Our Support Team</span>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
